export default "__VITE_ASSET__D$3OoKie__"